import styled from '@emotion/styled';
import { Paper, Typography } from '@material-ui/core';
import RoomIcon from '@material-ui/icons/Room';
import React from 'react';

export default function MapMarker({ property }) {
	const { id } = property;
	return (
			<Marker>
				<Icon />
				<Info>
					<Typography variant="body1">{id}</Typography>
				</Info>
			</Marker>
	);
}

const Icon = styled(RoomIcon)`
	color: #b60037;
	cursor: pointer;
	font-size: 32px;
	width: 45px;
	height: 45px;
`;
const Info = styled(Paper)`
	z-index: 0;
	text-align: center;
	min-width: 130px;
	padding: 0.5rem;
	position: absolute;
	top: 0;
	left: -42px;
	transition: all 0.2s ease-in;
	opacity: 0;
`;
const Marker = styled.div`
	transform: translate(-50%, -50%);
	z-index: 1;
	position: relative;
	&:hover {
		& > div {
			top: -45px;
			opacity: 1;
		}
	}
`;
